import { render, staticRenderFns } from "./labreport.vue?vue&type=template&id=2a5a517a&"
import script from "./labreport.vue?vue&type=script&lang=js&"
export * from "./labreport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports